import { addDays } from 'date-fns'
import { Format, Parse, setTime } from 'services/Dates'

type GetStartEndFromTimeDate = (options: { startDate?: Date; start: string; end: string }) => [string, string]

const getStartEndFromTimeDate: GetStartEndFromTimeDate = ({ startDate = new Date(), start: startTime, end: endTime }) => {
  const start = setTime(Parse(startDate, { inFormat: 'date' }), startTime)
  let end = Parse(startDate, { inFormat: 'date' })

  // Add a day if the start time is after the end time
  if (startTime > endTime) end = addDays(end, 1)

  // Set the time after adding the date, because otherwise there is an
  // issue with shifts finishing at 2AM during daylight savings change
  end = setTime(end, endTime)

  return [Format(start), Format(end)]
}

export default getStartEndFromTimeDate
